import { API_URI } from '../../constants/env';
import { IDashboardData } from '../../types/dashboard.types';
import instance from './axios';

const ENDPOINTS = {
  GETDASHBOARD: '/dashboard',
};

const getDashboard = () => {
  return instance.get<IDashboardData>(ENDPOINTS.GETDASHBOARD, {
    baseURL: API_URI + '/wp-json/kcc/v1',
  });
};

const DashboardApi = {
  getDashboard,
};

export default DashboardApi;